<dsy-sidebar
  specified-width="350px"
  render-side="right"
  z-index=100
  background-overlay-color="rgba(51, 51, 51, 0.5)"
  transition-duration="0.5s"
  renderSide="right"
  header-content="Right sidebar"
  headerContent={{templatePriority?.template_display_label}}
  defaultHeaderContent={{defaultHeaderContent}}
  closes-on-apply="closesApply"
  default-footer-content
  background-overlay
  scrollable
  [hideCloseIcon]="false"
  [cancelButtonDisabled]="false"
  [handleOpenCloseInteraction]="handleOpenCloseInteraction"
  [handleCancelButtonInteraction]="handleCancelButtonInteraction"
  [handleApplyButtonInteraction]="handleApplyButtonInteraction"
  [isOpen]="true">

  <span>Allows to assign the priority for this template based on the Event Type.</span>
  <hr class="hr m-3" />
  <div *ngFor="let eventType of templateEditedEventTypeSwitchers; let ind = index" class="mt-3">
        <span class="content-switcher-title">
            {{eventType.display_label}}
            <i *ngIf="eventType.name === 'OFFICIAL'"
               class="fa fa-info-circle"
               data-toggle="tooltip"
               data-placement="right"
               title="Configuration also applies to Official Low Reserve and Official High Reserve event types">
            </i>
        </span>
    <dsy-content-switcher
      [contentList]="eventType.switcher"
      [functionSetterData]="switcherComponent"
      [setIndexContentChosed]="setIndexContentChosed"
      [indexContentChosed]="eventType.priorityIndex"
      (click)="setSwitcherValue($event, eventType)"
    >
    </dsy-content-switcher>
  </div>

</dsy-sidebar>

<app-confirm-modal [message]="'Do you want to save changes?'" [openModal]="openConfirmCustomizationsModal" (outcome)="openCloseConfirmCustomizationsModal($event)"/>
